module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com.9c21aee3.svg";